import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import i18next from 'i18next';
import { enabledStates } from '../../config/states';
import './Nav.css';

const Nav = () => {
  const lang = localStorage.getItem('lang') || 'zh_CN';
  const [seatsOpen, setSeatsOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const seatsRef = useRef(null);
  const { pathname } = useLocation();
  const states = enabledStates();

  const handleLanguage = (e) => {
    localStorage.setItem('lang', e.currentTarget.value);
    window.location.reload();
  };

  useEffect(() => {
    const onClick = (e) => {
      if (seatsRef.current && !seatsRef.current.contains(e.target)) {
        setSeatsOpen(false);
      }
    };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setSeatsOpen(false);
  }, [pathname]);

  return (
    <nav className="nav-container" aria-label="Primary">
      <a href="/" aria-label="Oriental Daily">
        <div className="odaily-logo" />
      </a>
      {states[0]?.flag && (
        <img className="nav-state-flag" src={states[0].flag} alt="" />
      )}

      <button
        type="button"
        className="nav-burger"
        aria-label="Menu"
        aria-expanded={mobileOpen}
        onClick={() => setMobileOpen((v) => !v)}
      >
        <span />
        <span />
        <span />
      </button>

      <div className={`nav-menu ${mobileOpen ? 'is-open' : ''}`}>
        <ul className="nav-links">
          <li>
            <Link to="/" className={pathname === '/' ? 'is-active' : ''}>
              {i18next.t('主页')}
            </Link>
          </li>
          {states.length === 1 ? (
            <li>
              <Link
                to={`/seats/${states[0].slug}/n`}
                className={pathname.startsWith('/seats') ? 'is-active' : ''}
              >
                {i18next.t('议席列表')}
              </Link>
            </li>
          ) : (
            <li className="nav-dropdown" ref={seatsRef}>
              <button
                type="button"
                className={`nav-dropdown__toggle ${pathname.startsWith('/seats') ? 'is-active' : ''}`}
                aria-haspopup="true"
                aria-expanded={seatsOpen}
                onClick={() => setSeatsOpen((v) => !v)}
              >
                {i18next.t('议席列表')}
                <span className="nav-caret" aria-hidden="true">▾</span>
              </button>
              <ul className={`nav-dropdown__menu ${seatsOpen ? 'is-open' : ''}`}>
                {states.map((s) => (
                  <li key={s.slug}>
                    <Link to={`/seats/${s.slug}/n`}>
                      {i18next.t(s.nameKey)}
                      <span className="nav-seat-count">（{s.totalSeats}）</span>
                    </Link>
                  </li>
                ))}
              </ul>
            </li>
          )}
        </ul>

        <div className="lang-toggle">
          <button
            type="button"
            className={lang === 'zh_CN' ? 'is-active' : ''}
            onClick={handleLanguage}
            value="zh_CN"
            aria-label="简体"
          >
            简
          </button>
          <button
            type="button"
            className={lang === 'zh_TW' ? 'is-active' : ''}
            onClick={handleLanguage}
            value="zh_TW"
            aria-label="繁體"
          >
            繁
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Nav;
